/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 列举目录下的文件和子目录
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetFileNameAndSubDirParams {
  constructor(public dirPath: string) {}
}

export default async function (
  params: GetFileNameAndSubDirParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<string>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oss/fileNameAndSubDir/directory`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
